import React, { memo } from "react";
import PropTypes from "prop-types";
import { Icon, ICONS } from "../../Icons";
import { ErrorRoot, ErrorContainer } from "./styled";

/**
 * ErrorMessage component displays an error message with an error icon
 * @param {Object} props - Component props
 * @returns {React.ReactElement} React component
 */
const ErrorMessageBase = ({ error }) => {
  if (!error) return null;

  return (
    <ErrorRoot role="alert">
      <ErrorContainer>
        <Icon name={ICONS.error} alt="error" />
        <p>{error}</p>
      </ErrorContainer>
    </ErrorRoot>
  );
};

ErrorMessageBase.propTypes = {
  /** Error message text to display */
  error: PropTypes.string
};

export const ErrorMessage = memo(ErrorMessageBase);
